export function getUTCNow(){
    const date = new Date();
    const localDate = new Date();
    const utcOffset = localDate.getTimezoneOffset();
    return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
        date.getUTCHours() + (utcOffset / 60) , date.getUTCMinutes(), date.getUTCSeconds());

}